import { createContext, useContext } from 'react';

import { type APIStrategy } from '../services/strategy/api-strategy';

interface ApiStrategyContextData {
  api: APIStrategy;
}

export const ApiStrategyContext = createContext<
  Partial<ApiStrategyContextData>
>({});

export function useApiStrategyContext(): ApiStrategyContextData {
  return useContext(ApiStrategyContext) as ApiStrategyContextData;
}
